import React from 'react';
import './css/CustomMessageForm.css';
import { withFormCache } from './FormCacheResources';

// Define initial state for all form fields to be cached
const initialState = {
  numRequests: 1,
  message_type: "text",
  direction: "outbound",
  body: "test",
  username: "",
  alert: true,
  sound: "none",
  text_to_speech_announcement: "",
  form_code: "",
  form_data: ""
};

class CustomMessageForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClearForm = this.handleClearForm.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.name === 'alert' ? target.checked : target.value;
    const name = target.name;

    const currentFormState = this.props.formState;

    if (name === "message_type") {
      if (value === "text") {
        this.props.updateFields({ 
          form_code: "", 
          form_data: "",
          body: "test" 
        });
      } else if (value === "form") {
        this.props.updateFields({
          body: "",
          form_code: "1.39-START-STOP-O",
          form_data: '{"LOAD-NUMBER": "123","STOP-NUMBER": "2"}'
        });
      }
    }

    if (this.props[`set${name.charAt(0).toUpperCase()}${name.slice(1)}`]) {
      this.props[`set${name.charAt(0).toUpperCase()}${name.slice(1)}`](value);
    } else {
      this.props.updateField(name, value);
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.props.formState.username.length === 0) {
      alert("Username field required for custom message");
    } else if (!this.props.formState.body && !this.props.formState.form_code) {
      alert("Body or Form Code field required for custom message");
    } else if (this.props.formState.numRequests > 200) {
      alert("Number of Messages must be less than 200 for custom message");
    } else {
      this.props.MessageFunction(this.props.formState);
    }
  }

  handleClearForm() {
    this.props.clearForm();
  }

  render() {
    const handleMessageTypeSwitch = () => {
      if (this.props.formState.message_type === 'text') {
        return (
          <>
            <label className="CustomMessageForm-label">
              Body:
              <input 
                name="body" 
                type="text" 
                value={this.props.formState.body} 
                onChange={this.handleInputChange} 
                className="CustomMessageForm-input" 
              />
            </label>
          </>
        );
      } else {
        return (
          <>
            <label className="CustomMessageForm-label">
              Form Code:
              <input 
                name="form_code" 
                type="text" 
                value={this.props.formState.form_code} 
                onChange={this.handleInputChange} 
                className="CustomMessageForm-input" 
              />
            </label>
            <label className="CustomMessageForm-label">
              <p>Form Data:</p>
              <textarea
                className="CustomMessageForm-textarea form_data_textarea"
                cols={50}
                rows={4}
                name="form_data"
                value={this.props.formState.form_data}
                onChange={this.handleInputChange}
              />
            </label>
          </>
        );
      }
    };

    return (
      <div className="CustomMessageForm-container">
        <h3>Custom Message</h3>
        <form className="CustomMessageForm-form" onSubmit={this.handleSubmit}>
          <label className="CustomMessageForm-label">
            Direction:
            <select 
              value={this.props.formState.direction} 
              name="direction" 
              onChange={this.handleInputChange} 
              className="CustomMessageForm-select"
            >
              <option value="outbound">Outbound</option>
              <option value="inbound">Inbound</option>
            </select>
          </label>
          <label className="CustomMessageForm-label">
            Message Type:
            <select 
              value={this.props.formState.message_type} 
              name="message_type" 
              onChange={this.handleInputChange} 
              className="CustomMessageForm-select"
            >
              <option value="text">Text</option>
              <option value="form">Form</option>
            </select>
          </label>
          {handleMessageTypeSwitch()}
          <label className="CustomMessageForm-label">
            Number of Messages:
            <input
              type='number'
              name="numRequests"
              value={this.props.formState.numRequests}
              onChange={(event) => {
                const numericValue = event.target.value.replace(/\D/, '');
                if (this.props.setNumRequests) {
                  this.props.setNumRequests(numericValue);
                } else {
                  this.props.updateField('numRequests', numericValue);
                }
              }}
              className="CustomMessageForm-input"
            />
          </label>
          <label className="CustomMessageForm-label">
            Username:
            <input 
              name="username" 
              type="text" 
              value={this.props.formState.username} 
              onChange={this.handleInputChange} 
              className="CustomMessageForm-input" 
            />
          </label>
          <label className="CustomMessageForm-label CustomMessageForm-checkbox-label">
            Alert:
            <input
              name="alert"
              type="checkbox"
              checked={this.props.formState.alert}
              onChange={this.handleInputChange}
              className="CustomMessageForm-checkbox"
            />
          </label>
          <label className="CustomMessageForm-label">
            Sound:
            <select 
              value={this.props.formState.sound} 
              name="sound" 
              onChange={this.handleInputChange} 
              className="CustomMessageForm-select"
            >
              <option value="none">None</option>
              <option value="default">Default</option>
              <option value="honk">Honk</option>
              <option value="guitar">Guitar</option>
              <option value="echo">Echo</option>
              <option value="marimba">Marimba</option>
            </select>
          </label>
          <label className="CustomMessageForm-label">
            text_to_speech_announcement:
            <input
              name="text_to_speech_announcement"
              type="text"
              value={this.props.formState.text_to_speech_announcement}
              onChange={this.handleInputChange}
              className="CustomMessageForm-input"
            />
          </label>
          <div className="CustomMessageForm-button-group">
            <input type="submit" value="Send" className="CustomMessageForm-send-button" />
            <button type="button" className="CustomMessageForm-clear-button" onClick={this.handleClearForm}>Clear</button>
          </div>
        </form>
      </div>
    );
  }
}

export default withFormCache(CustomMessageForm, 'customMessageForm', initialState);